import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Route } from "react-router-dom";
import TopicPageViewsTopic from "./TopicPage_Views_Topic";
import TopicPageViewsTabs from "./TopicPage_Views_Tabs";
import TopicPageViewsActivity from "./TopicPage_Views_Activity";
import TopicPageViewsLabel from "./TopicPageViewsLabel";
import TopicPageViewsLabels from "./TopicPageViewsLabels";
const TopicPage = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\/]+)",
                component: TopicPageViewsTopic
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\\\/]+)/label/:labelId",
                component: TopicPageViewsLabel
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\\\/]+)/:view(archive|trash)",
                component: TopicPageViewsTabs
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\\\/]+)/:view(labels)",
                component: TopicPageViewsLabels
            }),
            /*#__PURE__*/ _jsx(Route, {
                exact: true,
                path: "/:username/:topicId(\\d+)-:topicTitle([^\\s\\\\/]+)/:view(activity)",
                component: TopicPageViewsActivity
            })
        ]
    });
};
export default TopicPage;
